//IDOGAN;453142;08042025
export const catheterMaterialFirstRows = [
    {
      id: 1,
      lastProcessType: "Başvuru Anında",
      processName: "Mertcan İŞKAR",
      user: "BYZ",
      time: "10.03.2025 20:55:04",
      complicationType: "Tip A",
      complicationDegree: "Derece 3",
      complicationDesc: "Açıklama 1",
    },
  ];
  
  export const catheterMaterialSecondRows = [
    {
      id: 1,
      processType: "Takma İşlemi",
      entryLocation: "Aksiller Arter",
      region: "Sol Kol İç",
      reason: "Sebep 1",
      applier: "SİNERJİ BİLİŞİM",
      stayDuration: "5 AY",
      expectedDuration: "5 AY",
    },
  ];
  